_ = require 'underscore'

module.exports = class GuidHelper
  setup: ->
    _.mixin
      isEmptyGuid: (value) =>
        return true unless value?
        return value.split("-").join("") is "00000000000000000000000000000000"
